import type {ReactElement} from 'react';
import {Text, TextSize} from '@Components/text';
import type {StoryGuidelineProps} from './social-media-publish-params-story-guideline.types';
import styles from './social-media-publish-params-story-guidelines.module.scss';

export function SocialMediaPublishParamsStoryGuideline({storyGuideline}: StoryGuidelineProps): ReactElement {
  return (
    <div className={styles.guidelineWrapper}>
      <div className={styles.emojiWrapper}>
        <Text val={storyGuideline.emoji} />
      </div>
      <Text className={styles.guidelineText} size={TextSize.SM} val={storyGuideline.text} />
    </div>
  );
}
